// @ts-check
import * as React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { getUsersAction } from '../redux/actions/user-actions';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';

import { useEffect } from 'react';
import { LoadingComponent } from '../../../clients/presentation/components/loading-component';
import { AlignItemsList } from '../components/user-list-component';
import { AddNewUserFab } from '../components/add-component';
import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  sectionHeading: {
    margin: theme.spacing(2)
  }
}));

export function UsersPage() {
  const classes = useStyles();

  const { users, loading } = useSelector((state) => state.users);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUsersAction());
  }, [dispatch]);

  return (
    <>
      <React.Fragment>
        <CssBaseline />
        <Container className={classes.container}>
          {loading && <LoadingComponent />}
          {!loading && (
            <>
              <BackNavigationComponent page="Users" uri="/" />
              <AlignItemsList users={users} />
              <AddNewUserFab />
            </>
          )}
        </Container>
      </React.Fragment>
    </>
  );
}
